import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const KTTooltipPositions = {
  autoStart: 'auto-start',
  auto: 'auto',
  autoEnd: 'auto-end',
  topStart: 'top-start',
  top: 'top',
  topEnd: 'top-end',
  rightStart: 'right-start',
  right: 'right',
  rightEnd: 'right-end',
  bottomEnd: 'bottom-end',
  bottom: 'bottom',
  bottomStart: 'bottom-start',
  leftEnd: 'left-end',
  left: 'left',
  leftStart: 'left-start',
};

KTTooltip.propTypes = {
  position: PropTypes.oneOf(Object.values(KTTooltipPositions)),
  text: PropTypes.string,
  textHeader: PropTypes.string,
  isHtmlContent: PropTypes.bool,
  offset: PropTypes.any,
};

function KTTooltip({
  position = KTTooltipPositions.top,
  text = '',
  textHeader = '',
  isHtmlContent = false,
  offset = 0,
  ...props
}) {
  return (
    <div>
      {text?.length > 0 ? (
        <OverlayTrigger
          placement={position}
          offset={offset}
          overlay={
            <Tooltip>
              <div
                className="text-left"
                style={{
                  ...UIHelper.buildFontStyle('700', '14px', AppColors.gray[800]),
                  fontFamily: 'Inter, sans-serif'
                }}
              >
                {textHeader}
              </div>

              {isHtmlContent ? (
                <div
                  className="font-weight-bold text-left"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              ) : (
                <div
                  className="text-left"
                  style={{
                    ...UIHelper.buildFontStyle('400', '14px', AppColors.gray[600]),
                    fontFamily: 'Inter, sans-serif'
                  }}
                >
                  {text}
                </div>
              )}
            </Tooltip>
          }
        >
          {props.children}
        </OverlayTrigger>
      ) : (
        <>{props.children}</>
      )}
    </div>
  );
}

export default KTTooltip;
